import React from 'react';
import heroImage from 'assets/images/hero-image.png';
import heroImage2x from 'assets/images/hero-image@2x.png';
import loginQuote from 'assets/images/login-quote.svg';
import styled from 'styled-components';

const LoginBanner: React.FC = ({}) => {
  return (
    <Container>
      <QuoteImage src={loginQuote} alt="Quote" />
      <BlurbText>The EPD Portal guides you step-by-step through the EPD registration and development process.</BlurbText>
      <DashboardImageWrapper>
        <DashboardImage
          src={heroImage}
          srcSet={`${heroImage} 1x, ${heroImage2x} 2x`}
          sizes="50vw"
          alt="EPD Portal Dashboard"
        />
      </DashboardImageWrapper>
    </Container>
  );
};

export default LoginBanner;

const Container = styled.div`
  position: fixed;
  width: 50%;
  background-color: ${(props) => props.theme.colors.secondaryLightGreen30};
  padding-top: 100px;
  padding-left: 98px;
  padding-right: 90px;
  min-height: 100vh;
  min-height: 100dvh;
`;

const QuoteImage = styled.img`
  position: absolute;
  top: 67px;
  left: 64px;
  z-index: -1;
`;

const BlurbText = styled.div`
  max-width: 532px;
  color: ${(props) => props.theme.colors.primaryBlack};
  font-family: Inter;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
`;

const DashboardImageWrapper = styled.div`
  position: relative;
`;

const DashboardImage = styled.img`
  position: absolute;
  top: 60px;
  width: 1222px;
  object-fit: contain;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
`;
